module.exports = __webpack_public_path__ + "img/skull.a9243d29.svg";